export const URL = {
  login: '~/common/login',
  logout: '~/common/logout',
  socialLogin: '~/common/social-login',
  usersProfile: '~/user/profile',
  userSessionEnd: '~/user/session/end',
  adminEditProfile: '~/admin/edit-profile',
  forgotPassword: '~/common/forgot-password',
  resetPassword: '~/common/reset-password',
  changePassword: '~/user/change-password',
  profileSetupStepOne: '~/common/signUpStep1',
  profileSetupStepTwo: '~/common/signUpStep2',
  countriesList: '~/user/country',
  stateList: '~/user/state',
  cityList: '~/user/city',
  addCertificates: '~/user/certificates',
  /**
   * @description
   * Users Search URLs
   */
  userSearch: '~/user/search',
  userFollowUnfollow: '~/user/follow',
  usersFollowerFollowingList: '~/user/follow-list',
  userSquawkpitTopicList: '~/user/questionListing',
  nearbyUserSearch: '~/user/nearByPeople',
  addUserLocation: '~/user/addLocation',
  userPost: '~/user/userPost',

  followTopic: '~/user/followTopic',


  /**
   * ! Squawkit urls
   * @params
   * squawkpit topic endpoints (questions,answers,reply)
   */
  topics: '~/user/topic',
  deleteTopic: (id: string) => `~/user/topic/${id}`,
  topicCategoryList: '~/user/topic-category-list',
  topicsAnswers: '~/user/topic-answer',


  topicQuestionReport: (id: string, reportReason: string) => `~/user/topic-question-report/${id}/${reportReason}`,
  topicAnswerReport: (id: string, reportReason: string) => `~/user/topic-answer-report/${id}/${reportReason}`,
  topicAnswerReplyReport: (id: string, reportReason: string) => `~/user/topic-reply-report/${id}/${reportReason}`,



  topicsAnswerReplyHide: (id: string, action: string) => `~/user/topic-reply-hide/${id}/${action}`,
  topicAnswerHide: (id: string, action: string) => `~/user/topic-answer-hide/${id}/${action}`,
  topicQuestionHide: (id: string, action: string) => `~/user/topic-question-hide/${id}/${action}`,

  deleteTopicAnswer: (answerId: string, questionId: string) => `~/user/topic-answer/${answerId}/${questionId}`,
  topicQuestionVote: '~/user/topic-question/vote',
  topicUpVoteList: '~/user/topic-upvote-list',
  topicAnswerVote: '~/user/topic-answer/vote',
  topicDownVoteList: '~/user/topic-downvote-list',
  topicDetails: (id: string) => `~/user/topic-details/${id}`,
  topicsAnswerReply: '~/user/topic-reply',

  topicAnswerReplyDelete: (id: string, answerId: string) => `~/user/topic-reply/${id}/${answerId}`,
  trendingTopics: '~/user/top-trending-topic',

  /**
   * !Business module urls
   * @params
   * business related urls
   */
  aviationBusiness: '~/user/aviation-business',
  businessCategory: '~/user/business-category',
  myBusiness: '~/user/my-business',
  businessDetails: (id: string) => `~/user/business/${id}`,
  business: '~/user/business',
  businessReport: '~/business/report',

  businessFeedback: '~/user/business-feedback',
  deleteBusinessFeedback: (id: string) => `~/user/business-feedback/${id}`,
  businessFollowUnfollow: '~/user/businessFollow',
  userFollowedBusinessList: '~/user/business-followList',
  businessUserFollowed: '~/user/followers-businessList',
  userFeedbackList: '~/user/reviewListing',
  businessType: '~/user/business-type',
  /**
   * @description
   * google and yelp business apis
   */

  googleBusinessApi: '~/user/google-places',
  yelpBusinessApi: '~/user/yelp-places',
  uploadChatImage: '~/common/upload/file',

  //old api for quiz
  // quizApi: '~/user/quiz',
  quizComplete: '~/user/quiz-profile',

  // new api for quiz
  quizApi: '~/user/quiz-question',
  quizAnswerApi: '~/user/quiz-answers',
  quizSubmitApi: '~/user/quiz-update',

  //   getLevelOneById(payload){
  //     return this.$http.get(URL.levelOneApi,payload).toPromise();
  //  }


  /**
   * @description
   * mobile verification apis
   */
  sendOtp: '~/test-sms',
  resendOtp: '~/common/resendOTP',
  verifyOtp: '~/common/verifyOTP',

  /**
   * @description
   * events module
   */
  event: '~/user/event',
  eventCategory: '~/user/event-category',
  eventDetails: (id: string) => `~/user/event/${id}`,
  deleteEvent: (id: string) => `~/user/event/${id}`,


  /**
   * @description
   * post module apis
   */
  posts: '~/user/post',
  postComments: '~/user/post-comment',
  postLike: '~/user/post-like',
  deletePost: (id: string) => `~/user/post/${id}`,
  deletePostComment: (id: string) => `~/user/post-comment/${id}`,
  postDetails: '~/user/postDetails',
  postCommentListing: '~/user/postCommentListing',
  postCommentReply: '~/user/post-comment-reply',
  deleteCommentReply: (replyId: string, commentId: string) => `~/user/post-comment-reply/${replyId}/${commentId}`,
  hidePost: (id: string, action: string) => `~/user/hidePost/${id}/${action}`,
  // reportPost:'~/user/reportPost',
  reportPost: (id: string, reason: string) => `~/user/reportPost/${id}/${reason}`,
  reportPostComment: (id: string, reason: string) => `~/user/reportComment/${id}/${reason}`,
  reportCommentReply: (replyId: string, commentId: string, reason: string) => `~/user/reportCommentReply/${replyId}/${commentId}/${reason}`,
  hideComment: (commentId: string, action: string) => `~/user/hideComment/${commentId}/${action}`,
  hideCommentReply: (replyId: string, commentId: string, action: string) => `~/user/hideCommentReply/${replyId}/${commentId}/${action}`,
  likeUnlikeComment: '~/user/comment-like',
  commentDetails: '~/user/postComment-details',
  /**
   * @abstract
   * recent searches
   */
  recentSearches: '~/user/recentSearch',

  /**
   * @description advertisement
   */
  advertisement: '~/user/advertiseForm',
  advertisementList: '~/user/advertiseListing',
  /**
   * @description  notifications
   */
  notificationMarkAll: '~/notificationMark-allRead',
  updateDeviceToken: '~/user/deviceTokenUpdate',
  notificationAction: (status: string) => `~/user/notification-action?action=${status}`,
  updateNotificationStatus: '~/notification-status',
  chatNotifications: '~/chatNotification',
  notification: '~/notification',
  notificationStatus: (id: string) => `~/notification-status?notificationId=${id}`,
  notificationDelete: (notificationId: string) => `~/notification/${notificationId}`,
  clearAllNotification: '~/clearAll-notification',
  readChatNotification: '~/read-chat-notification',

  /**
   * @description content management api
   */
  contentManagement: '~/content/type-view',
  // contentManagement: '~/content/view',
  contactUs: '~/user/contact-us',
  // GET / v1 / content / type - view

  /**
   * @description
   * avtopia business apis
   */
  avtopiaBusiness: '~/user/avtopia-business',
  avtopiaBusinessDetails: (id: string) => `~/user/avtopia-business-details/${id}`,

  blockUnblockUser: '~/user/block-unblock',
  blockUserList: '~/user/block',

  /**
   * @description
   * Community Groups APIs
   */
  communityGroups: '~/community-groups',
  communityGroupDetails: (groupId: string) => `~/community-groups/${groupId}`,
  communityGroupUpdate: (groupId: string) => `~/community-groups/${groupId}`,
  communityGroupMembers: (groupId: string) => `~/community-groups/${groupId}/members`,
  communityGroupAddMembers: (groupId: string) => `~/community-groups/${groupId}/members`,
  communityGroupRemoveMember: (groupId: string, userId: string) => `~/community-groups/${groupId}/members/${userId}`,
  communityGroupPosts: (groupId: string) => `~/community-groups/${groupId}/posts`,
  communityGroupCreatePost: (groupId: string) => `~/community-groups/${groupId}/posts`,
  communityGroupSyncCometChat: (groupId: string) => `~/community-groups/${groupId}/cometchat/sync`,
  communityGroupJoin: (groupId: string) => `~/community-groups/${groupId}/join`,
  communityGroupDelete: (groupId: string) => `~/community-groups/${groupId}`,
  /**
   * @description
   * Invite/Referral URLs
   */
  getInviteLink: '~/user/invite-link',
  recordInviteClick: '~/common/invite-click',
  getInviteInfo: '~/common/invite-info',
  getUserReferrals: '~/user/referrals',
  adminGetAllReferrals: '~/admin/referrals',
  adminGetUserReferrals: (userId: string) => `~/admin/referrals/user/${userId}`
}
